"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[992],{

/***/ 2344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ UserProvider; },
  "e": function() { return /* binding */ useUserState; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
;// CONCATENATED MODULE: ./src/mocks/mockuser.json
var mockuser_namespaceObject = JSON.parse('{"id":1522742,"name":"Test Account","email":"Test.Account@themuse.com","cropped_name":"Tester","favorite_posts":[{"id":655045,"post_id":10493},{"id":677478,"post_id":24282}],"company":{"id":894,"short_name":"yext","name":"Yext"},"logged_in":true,"view_bookings":false,"location":{"city":"New York","region":"New York","country":"United States","dma":"New York, NY","lat":40.7524,"lon":-73.9875,"accuracy_radius":10}}');
;// CONCATENATED MODULE: ./src/hooks/UserContext.tsx










var defaultUserState = {
    isInitialized: false,
    logged_in: false,
    view_bookings: false
};
var UserContext = /*#__PURE__*/ react.createContext(defaultUserState);
var UserProvider = function(props) {
    var children = props.children, user = props.user, userLocation = props.userLocation;
    var initialState = user ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
        location: userLocation
    }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultUserState), {
        location: userLocation
    });
    var ref = (0,react.useState)(initialState), userState = ref[0], setUserState = ref[1];
    (0,react.useEffect)(function() {
        var isMounted = true;
        var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, museApiHost = _publicRuntimeConfig.museApiHost, appName = _publicRuntimeConfig.appName;
        var fetchUser = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, msg;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if ([
                                "www.themuse.com",
                                "https://www.staging-themuse.com/"
                            ].includes(window.location.host)) {
                                _ctx.next = 4;
                                break;
                            }
                            {
                                setUserState(mockuser_namespaceObject);
                            }
                            _ctx.next = 16;
                            break;
                        case 4:
                            _ctx.prev = 4;
                            _ctx.next = 7;
                            return axios_default().get("".concat(museApiHost, "/api/user"), {
                                timeout: apiRequestTimeoutMs
                            });
                        case 7:
                            response = _ctx.sent;
                            if (response && isMounted) {
                                setUserState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, response.data), {
                                    location: userState.location,
                                    isInitialized: true
                                }));
                            }
                            _ctx.next = 16;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](4);
                            msg = "".concat(appName, " was unable to fetch current user from ").concat(museApiHost, "/api/user.");
                            console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
                                error: _ctx.t0
                            })));
                            setUserState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userState), {
                                isInitialized: true
                            }));
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        11
                    ]
                ]);
            }));
            return function fetchUser() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchUser();
        return function() {
            isMounted = false;
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserContext.Provider, {
        value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userState), {
            location: userLocation
        }),
        children: children
    });
};
var useUserState = function() {
    var context = react.useContext(UserContext);
    if (context === undefined) {
        throw new Error("useUserState must be used within the SearchProvider");
    }
    return context;
};



/***/ }),

/***/ 2919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ formatJobsResponse; },
/* harmony export */   "q": function() { return /* binding */ getMuseJobsConfig; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9815);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1752);
/* harmony import */ var _utils_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7228);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3135);



/* eslint-disable camelcase */ 


/**
 * Formatter for The Muse Jobs.
 * This is the default.
 */ var getFormattedQueryParams = function() {
    var queryParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, queryParams, queryParams.query && {
        query: queryParams.query.substring(0, _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .jobSearchQueryMaxlength */ .L8)
    });
};
/**
 * Returns the Axios config for requesting Jobs from TheMuse.
 */ var getMuseJobsConfig = function(queryParams, ctsEnabled, cookies) {
    var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_0__["default"])(), jobsApiHost = ref.serverRuntimeConfig.jobsApiHost;
    var ref1 = (0,next_config__WEBPACK_IMPORTED_MODULE_0__["default"])(), _publicRuntimeConfig = ref1.publicRuntimeConfig, apiBase = _publicRuntimeConfig.apiBase, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs;
    var searchVersion = ctsEnabled ? "cts_search" : "search";
    var path = (0,_utils_browser__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU)() ? "".concat(apiBase, "/jobs?ctsEnabled=").concat(ctsEnabled) : "".concat(jobsApiHost, "/api/v2/").concat(searchVersion, "/jobs");
    var formattedQueryParams = getFormattedQueryParams(queryParams);
    var museConfig = {
        method: "GET",
        url: path,
        headers: (0,_utils_browser__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU)() ? {} : {
            Cookie: cookies || ""
        },
        params: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, formattedQueryParams), {
            timeout: apiRequestTimeoutMs
        })
    };
    return museConfig;
};
var formatJobsResponse = function(jobsResponse) {
    var ref;
    var _count = jobsResponse.count, count = _count === void 0 ? 0 : _count, _hits = jobsResponse.hits, hits = _hits === void 0 ? [] : _hits;
    var cleanHits = hits.map(function(x) {
        var result = x;
        delete result.hit.company.perks_and_benefits;
        delete result.hit.company.leadership_attributes;
        delete result.hit.company["package"];
        return result;
    });
    var results = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(cleanHits);
    var ref1;
    return {
        totalCount: count,
        results: results,
        // set the outer cursor to the last one in the set.
        cursor: (ref1 = (ref = results[results.length - 1]) === null || ref === void 0 ? void 0 : ref.cursor) !== null && ref1 !== void 0 ? ref1 : ""
    };
};



/***/ }),

/***/ 7248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ formatLocations; },
/* harmony export */   "z": function() { return /* binding */ getLocationConfig; }
/* harmony export */ });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1752);

/**
 * formatMuseLocationResponse: Formatter for Muse locations.
 * This is the default.
 */ var formatMuseLocationResponse = function(content) {
    if (!(content === null || content === void 0 ? void 0 : content.length)) {
        return [];
    }
    return content.map(function(location) {
        return {
            label: location === null || location === void 0 ? void 0 : location.label,
            latitude: location === null || location === void 0 ? void 0 : location.latitude,
            longitude: location === null || location === void 0 ? void 0 : location.longitude,
            remote_work_location_type: location === null || location === void 0 ? void 0 : location.remote_work_location_type,
            value: location === null || location === void 0 ? void 0 : location.label,
            id: null
        };
    });
};
/**
 * formatLocations: Cleanup the results from a location request for use within the location suggestor.
 * formerly formatLocationResponse
 */ var formatLocations = function(content) {
    return formatMuseLocationResponse(content);
};
/**
 * Returns the Axios config for requesting locations from TheMuse.
 */ var getMuseLocationConfig = function(searchText) {
    var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_0__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiBase = _publicRuntimeConfig.apiBase, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs;
    return {
        url: "".concat(apiBase, "/locations?query=").concat(searchText),
        method: "GET",
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        },
        timeout: apiRequestTimeoutMs
    };
};
/**
 * Returns the Axios config for requesting locations.
 */ var getLocationConfig = function(searchText) {
    var config = getMuseLocationConfig(searchText);
    return config;
};



/***/ }),

/***/ 1557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC": function() { return /* binding */ fetchCompanySuggestions; },
/* harmony export */   "bG": function() { return /* binding */ fetchJobs; },
/* harmony export */   "gy": function() { return /* binding */ fetchLocationSuggestions; },
/* harmony export */   "zA": function() { return /* binding */ fetchJobRecommendations; }
/* harmony export */ });
/* unused harmony exports getCompanyAttributesConfig, fetchCompanyAttributes, fetchApiCompanySuggestions, fetchLocations, formatLocationResponse, fetchApiLocationSuggestions, formatCompanySuggestions */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6042);
/* harmony import */ var regenerator_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5666);
/* harmony import */ var regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1752);
/* harmony import */ var utils_logging__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4453);
/* harmony import */ var orm_jobs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2919);
/* harmony import */ var orm_locations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7248);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3135);









/**
 * Request company suggestions.
 */ var fetchCompanySuggestions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(inputValue) {
        var ref, _publicRuntimeConfig, apiBase, apiRequestTimeoutMs, appName, path, response, msg;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiBase = _publicRuntimeConfig.apiBase, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, appName = _publicRuntimeConfig.appName;
                    path = "".concat(apiBase, "/companies?query=").concat(inputValue);
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default()(path, {
                        timeout: apiRequestTimeoutMs
                    });
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    msg = "".concat(appName, " was unable to request company suggestions from ").concat(path);
                    console.error(msg, JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_3__/* .formatLog */ .U)({
                        error: _ctx.t0
                    })));
                    throw new Error(msg);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    }));
    return function fetchCompanySuggestions(inputValue) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Returns the Axios config for requesting Jobs from TheMuse.
 */ var getCompanyAttributesConfig = function() {
    var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), _serverRuntimeConfig = ref.serverRuntimeConfig, companyApiHost = _serverRuntimeConfig.companyApiHost, companyApiToken = _serverRuntimeConfig.companyApiToken;
    var ref1 = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), apiRequestTimeoutMs = ref1.publicRuntimeConfig.apiRequestTimeoutMs;
    var path = "".concat(companyApiHost, "/api/v1/companies/attributes");
    var museConfig = {
        method: "GET",
        url: path,
        timeout: apiRequestTimeoutMs,
        headers: {
            Authorization: "Bearer ".concat(companyApiToken)
        }
    };
    return museConfig;
};
var fetchCompanyAttributes = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, appName, axiosConfig, response, ormResults, msg;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), appName = ref.serverRuntimeConfig.appName;
                    axiosConfig = getCompanyAttributesConfig();
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default()(axiosConfig);
                case 5:
                    response = _ctx.sent;
                    ormResults = response.data;
                    return _ctx.abrupt("return", ormResults);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](2);
                    msg = "".concat(appName, " was unable to request company attributes from ").concat(axiosConfig.url);
                    console.error(msg, JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_3__/* .formatLog */ .U)({
                        error: _ctx.t0
                    })));
                    throw new Error(msg);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                10
            ]
        ]);
    }));
    return function fetchCompanyAttributes() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request location suggestions.
 */ var fetchLocationSuggestions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(inputValue) {
        var ref, appName, config, response, msg;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), appName = ref.serverRuntimeConfig.appName;
                    ;
                    if (inputValue) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 4:
                    _ctx.prev = 4;
                    config = (0,orm_locations__WEBPACK_IMPORTED_MODULE_5__/* .getLocationConfig */ .z)(inputValue);
                    _ctx.next = 8;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default()(config);
                case 8:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](4);
                    msg = "".concat(appName, " was unable to request locations suggestions from ").concat(config === null || config === void 0 ? void 0 : config.url);
                    console.error(msg, JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_3__/* .formatLog */ .U)({
                        error: _ctx.t0
                    })));
                    throw new Error(msg);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                12
            ]
        ]);
    }));
    return function fetchLocationSuggestions(inputValue) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request job recommendations.
 */ var fetchJobRecommendations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, _publicRuntimeConfig, apiBase, apiRequestTimeoutMs, appName, path, response, msg;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, apiBase = _publicRuntimeConfig.apiBase, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, appName = _publicRuntimeConfig.appName;
                    path = "".concat(apiBase, "/recommendations");
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().get(path, {
                        timeout: apiRequestTimeoutMs
                    });
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    msg = "".concat(appName, " was unable to request job recommendations from ").concat(path);
                    console.error(msg, JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_3__/* .formatLog */ .U)({
                        error: _ctx.t0
                    })));
                    throw new Error(msg);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    }));
    return function fetchJobRecommendations() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request jobs directly from the backend API or proxied through the Next.js internal API.
 */ var fetchJobs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(queryParams, ctsEnabled, cookies) {
        var ref, appName, axiosConfig, response, msg;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), appName = ref.publicRuntimeConfig.appName;
                    axiosConfig = (0,orm_jobs__WEBPACK_IMPORTED_MODULE_4__/* .getMuseJobsConfig */ .q)(queryParams, ctsEnabled, cookies);
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default()(axiosConfig);
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    msg = "".concat(appName, " was unable to request job results from ").concat(axiosConfig.url);
                    console.error(msg, JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_3__/* .formatLog */ .U)({
                        error: _ctx.t0
                    })));
                    throw new Error(msg);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    }));
    return function fetchJobs(queryParams, ctsEnabled, cookies) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request company suggestions from the backend API.
 */ var fetchApiCompanySuggestions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(query) {
        var ref, _serverRuntimeConfig, apiRequestTimeoutMs, jobsApiHost, appName, queryObj, config, path, response, msg;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), _serverRuntimeConfig = ref.serverRuntimeConfig, apiRequestTimeoutMs = _serverRuntimeConfig.apiRequestTimeoutMs, jobsApiHost = _serverRuntimeConfig.jobsApiHost, appName = _serverRuntimeConfig.appName;
                    queryObj = query ? {
                        query: query
                    } : {};
                    config = {
                        params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                            type: "company_name"
                        }, queryObj),
                        timeout: apiRequestTimeoutMs
                    };
                    path = "".concat(jobsApiHost, "/api/v2/suggestions");
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default()(path, config);
                case 7:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](4);
                    msg = "".concat(appName, " was unable to request job suggestions server side from ").concat(path);
                    console.error(msg, JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_3__/* .formatLog */ .U)({
                        error: _ctx.t0
                    })));
                    throw new Error(msg);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                11
            ]
        ]);
    }));
    return function fetchApiCompanySuggestions(query) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request locations from the backend API.
 */ var fetchLocations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userInput) {
        var location, ref, jobsApiHost, _publicRuntimeConfig, apiRequestTimeoutMs, appName, config, path, response, msg;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    location = userInput === null || userInput === void 0 ? void 0 : userInput.substring(0, _constants__WEBPACK_IMPORTED_MODULE_6__/* .suggestionApiQueryMaxlength */ .BU);
                    ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), jobsApiHost = ref.serverRuntimeConfig.jobsApiHost, _publicRuntimeConfig = ref.publicRuntimeConfig, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs, appName = _publicRuntimeConfig.appName;
                    config = {
                        params: {
                            type: "location",
                            query: (location === null || location === void 0 ? void 0 : location.length) > 0 && location
                        },
                        timeout: apiRequestTimeoutMs
                    };
                    path = "".concat(jobsApiHost, "/api/v2/suggestions");
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().get(path, config);
                case 7:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](4);
                    msg = "".concat(appName, " was unable to request locations server side from ").concat(path);
                    console.error(msg, JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_3__/* .formatLog */ .U)({
                        error: _ctx.t0
                    })));
                    throw new Error(msg);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                11
            ]
        ]);
    }));
    return function fetchLocations(userInput) {
        return _ref.apply(this, arguments);
    };
}();
var formatLocationResponse = function(response) {
    return response.map(function(location) {
        return {
            label: location.text,
            value: location.text,
            latitude: location.value.latitude,
            longitude: location.value.longitude,
            remote_work_location_type: location.value.remote_work_location_type
        };
    });
};
var fetchApiLocationSuggestions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userInput) {
        var locationsResponse;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchLocations(userInput);
                case 2:
                    locationsResponse = _ctx.sent;
                    return _ctx.abrupt("return", formatLocationResponse(locationsResponse.data));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchApiLocationSuggestions(userInput) {
        return _ref.apply(this, arguments);
    };
}();
var formatCompanySuggestions = function(suggestions) {
    return suggestions.map(function(company) {
        return {
            label: company.text,
            value: company.value.short_name
        };
    });
};


/***/ })

}]);